export const VALUE_FLAT_RATE_TYPE = 'flat';
export const VALUE_PERCENTAGE_TYPE = 'percent';
